// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uLJTyxCFZTI16HbtzA3w {
  display: flex;
  min-height: 100dvh;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    116.81deg,
    rgba(3, 120, 209, 0.25) -7.65%,
    rgba(255, 255, 255, 0.25) 71.29%
  );
}

.AOd0HsBLI5S4JY5rOqp5 {
  width: 100%;
  border-radius: 5px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 2rem;
  padding-bottom: 4rem;
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

@media (min-width: 640px) {

  .AOd0HsBLI5S4JY5rOqp5 {
    width: 95%;
  }
}

@media (min-width: 768px) {

  .AOd0HsBLI5S4JY5rOqp5 {
    width: 85%;
  }
}

@media (min-width: 1024px) {

  .AOd0HsBLI5S4JY5rOqp5 {
    width: 60%;
  }
}

.AOd0HsBLI5S4JY5rOqp5 {
  background: linear-gradient(
    287deg,
    rgba(3, 120, 209, 0.08) -7.65%,
    rgba(255, 255, 255, 0.08) 71.29%
  );
}

.mrBrMTwf0eiQAR3ykeNs {
  width: 100%;
  border-radius: 5px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

@media (min-width: 640px) {

  .mrBrMTwf0eiQAR3ykeNs {
    width: 95%;
  }
}

@media (min-width: 768px) {

  .mrBrMTwf0eiQAR3ykeNs {
    width: 90%;
  }
}

@media (min-width: 1024px) {

  .mrBrMTwf0eiQAR3ykeNs {
    width: 40%;
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
}

.mrBrMTwf0eiQAR3ykeNs {
  background: linear-gradient(
    116.81deg,
    rgba(3, 120, 209, 0.08) -7.65%,
    rgba(255, 255, 255, 0.08) 71.29%
  );
}
.pRqQf9LVFmb3LuQLK1rC {
  height: 1.25rem;
  width: 1.25rem;
}
@media (min-width: 1024px) {

  .pRqQf9LVFmb3LuQLK1rC {
    height: 0.75rem;
    width: 0.75rem;
  }
}

.mrBrMTwf0eiQAR3ykeNs .ant-input-outlined {
  border-radius: 5px !important;
}

.Qt9H8mMtyKiYtDJSs_aK {
  margin-bottom: 1rem;
  text-align: center;
  font-family: Noto Sans;
  font-size: 34px;
  font-weight: 700;
}

@media (min-width: 1024px) {

  .Qt9H8mMtyKiYtDJSs_aK {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
.axXbqR0fo7PtPQdqXJ4f {
  margin-top: 1.25rem;
  white-space: nowrap;
  text-align: center;
  font-family: Noto Sans;
  font-size: 48px;
  font-weight: 800;
}
@media (min-width: 1024px) {

  .axXbqR0fo7PtPQdqXJ4f {
    margin-top: 0px;
    font-size: 48px;
    font-weight: 700;
  }
}
.FtvJ8h8jI0UejcfzyRim {
  margin-top: 0.5rem;
  margin-bottom: 3rem;
  text-align: center;
  font-size: 28px;
  font-weight: 400;
}
@media (min-width: 1024px) {

  .FtvJ8h8jI0UejcfzyRim {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.K342D5ZpqRD2D2RgaHqQ {
  margin-top: 1.25rem;
  display: flex;
  justify-content: center;
  gap: 1rem;
}
.TfAbDrjgSN0wI8UpfNMg {
  height: 110px;
  width: 100%;
  border-radius: 5px;
  border-width: 1px;
  border-style: solid;
  --tw-border-opacity: 1;
  border-color: rgb(228 228 228 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(242 242 242 / var(--tw-bg-opacity, 1));
  text-align: center;
  font-size: 1.875rem;
  line-height: 2.25rem;
  font-weight: 500;
}
@media (min-width: 1024px) {

  .TfAbDrjgSN0wI8UpfNMg {
    height: 60px;
    width: 60px;
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.TfAbDrjgSN0wI8UpfNMg {
  outline: none;
}

.x7i4UGtc2w2XB44OI2wj {
  margin-top: 0.5rem;
  margin-bottom: 3rem;
  text-align: center;
  font-size: 28px;
  font-weight: 400;
}

@media (min-width: 1024px) {

  .x7i4UGtc2w2XB44OI2wj {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}

.J9JydlldFNnMk0_p5pBD {
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
}

.rky8XFw8bdVaUG6yGu7s {
  height: 3rem;
  width: 330px;
}

@media (min-width: 1024px) {

  .rky8XFw8bdVaUG6yGu7s {
    height: 2rem;
    width: 200px;
  }
}

.SlZj8TwiOCtKZsqIbyD_ {
  height: 44px;
  width: 220px;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(46 49 146 / var(--tw-bg-opacity, 1)) !important;
  font-family: Noto Sans;
  font-size: 14px;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.SlZj8TwiOCtKZsqIbyD_:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

/* .cancelBtn {
  @apply bg-danger-800 text-white text-2xl lg:text-base font-semibold lg:font-normal px-6 py-2 !w-52 lg:!w-[130px] !h-[60px] lg:!h-[38px] mr-2;
} */
.UJ39q2ypqv9eDgaR0uFj {
  margin-right: 0px;
  height: 42px !important;
  width: auto !important;
  --tw-bg-opacity: 1;
  background-color: rgb(244 49 49 / var(--tw-bg-opacity, 1));
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.UJ39q2ypqv9eDgaR0uFj:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(244 49 49 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.nEBmZhLgw7m6cA9VQUH7 {
  /* @apply flex gap-5 flex-col md:flex-row; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1.25rem;
}

@media (min-width: 1024px) {

  .nEBmZhLgw7m6cA9VQUH7 {
    flex-direction: row;
  }
}

.YgPj0EI3rUd7lGXB95f7 {
  /* @apply flex flex-col flex-1 p-5 gap-5 bg-white rounded-lg cursor-pointer select-none; */
  width: 100%;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  border-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding: 1.25rem;
}

@media (min-width: 1024px) {

  .YgPj0EI3rUd7lGXB95f7 {
    width: 50%;
  }
}

.EMU1fk3VRPMuOzc7nWE3 {
  display: flex;
  justify-content: space-between;
}

.raWqWYWcpKbw_PwAfVv5 {
  width: 2.5rem;
}

.Hn5vejhSU6cpb8_lfRjv {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.gzEUwuHQPRJI4XRVCDwQ {
  font-size: 28px;
  font-weight: 600;
}

@media (min-width: 1024px) {

  .gzEUwuHQPRJI4XRVCDwQ {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}

.n3LfLfdgzlh49W9PDwuA {
  font-size: 23px;
  font-weight: 400;
}

@media (min-width: 1024px) {

  .n3LfLfdgzlh49W9PDwuA {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}

.rGFrRhxZYBN_RrEpgUQn {
  margin-top: 1.75rem;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  text-align: center;
  font-family: Noto Sans;
  font-size: 1.875rem;
  line-height: 2.25rem;
  --tw-text-opacity: 1;
  color: rgb(3 120 209 / var(--tw-text-opacity, 1));
}

@media (min-width: 1024px) {

  .rGFrRhxZYBN_RrEpgUQn {
    padding-top: 1.25rem;
    font-size: 13px;
  }
}

/* .signpassButton {
  @apply bg-danger-600 text-white w-full font-bold lg:font-semibold lg:w-fit h-[85px] lg:h-[40px] text-3xl lg:text-base;
}
.signpassButton:hover {
  @apply !bg-danger-600 !text-white;
}

.mykadButton {
  @apply bg-mykadColor text-white font-bold lg:font-semibold w-full lg:w-fit h-[85px] lg:h-[40px] text-3xl lg:text-base;
}
.mykadButton:hover {
  @apply !bg-mykadColor !text-white;
}
.primaryBtn {
  @apply !bg-primary font-bold lg:font-semibold text-white  hover:!text-white w-full lg:w-fit h-[85px] lg:h-[40px] text-3xl lg:text-base px-3;
} */

.ZZmH6LLjddJZQ49D6XGX {
  height: 56px;
  width: 100%;
  --tw-bg-opacity: 1;
  background-color: rgb(244 51 61 / var(--tw-bg-opacity, 1));
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

@media (min-width: 1024px) {

  .ZZmH6LLjddJZQ49D6XGX {
    height: 52px;
    width: -moz-fit-content;
    width: fit-content;
  }
}

.ZZmH6LLjddJZQ49D6XGX:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(244 51 61 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.vj2NL9QHGFCj5NDShvac {
  height: 56px;
  width: 100%;
  --tw-bg-opacity: 1;
  background-color: rgb(46 49 146 / var(--tw-bg-opacity, 1));
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

@media (min-width: 1024px) {

  .vj2NL9QHGFCj5NDShvac {
    height: 52px;
    width: -moz-fit-content;
    width: fit-content;
  }
}

.vj2NL9QHGFCj5NDShvac:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(46 49 146 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.UXRryY5q1IqERHZaYJQa {
  height: 56px;
  width: 100%;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1)) !important;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.UXRryY5q1IqERHZaYJQa:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

@media (min-width: 1024px) {

  .UXRryY5q1IqERHZaYJQa {
    height: 52px;
    width: -moz-fit-content;
    width: fit-content;
  }
}

.HGbkvu4_bl6OFoZEndgz {
  width: 100px;
}

@media (min-width: 1024px) {

  .HGbkvu4_bl6OFoZEndgz {
    width: 70px;
  }
}
.YCFdm0CoUtqJmEiy8FVg {
  padding-left: 1rem;
  padding-right: 1rem;
}
@media (min-width: 1024px) {

  .YCFdm0CoUtqJmEiy8FVg {
    padding-left: 5rem;
    padding-right: 5rem;
  }
}
@media (min-width: 1280px) {

  .YCFdm0CoUtqJmEiy8FVg {
    padding-left: 10rem;
    padding-right: 10rem;
  }
}
.LxcUsCy4r8LcpQ47HoJr {
  display: flex;
  min-height: 80px;
  width: 100%;
  flex-direction: column;
  align-items: center;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
@media (min-width: 1024px) {

  .LxcUsCy4r8LcpQ47HoJr {
    flex-direction: row;
    justify-content: space-between;
  }
}
/* .pledgeListButtonWrapper {
  @apply flex flex-col lg:flex-row lg:justify-end gap-9 lg:gap-2 items-center my-5 w-full lg:w-[70%];
} */
.gv6XIKf7c7RWyIp3sBGF {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}
@media (min-width: 1024px) {

  .gv6XIKf7c7RWyIp3sBGF {
    width: 70%;
    flex-direction: row;
    justify-content: flex-end;
    gap: 0.75rem;
  }
}
.ydCuPGNWxOGPDFEX8hCo {
  margin-bottom: 1rem;
  margin-top: 3.5rem;
}
@media (min-width: 1024px) {

  .ydCuPGNWxOGPDFEX8hCo {
    margin-top: 0.5rem;
  }
}
/* .pledgeListInnerWrapperHeader {
  @apply flex justify-between items-center;
} */
.uMNcmnGq3NFS2QeG54M4 {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
@media (min-width: 1024px) {

  .uMNcmnGq3NFS2QeG54M4 {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
}

.uMNcmnGq3NFS2QeG54M4 > div {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
}

.uMNcmnGq3NFS2QeG54M4 .ant-checkbox-wrapper {
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 500;
}

.uMNcmnGq3NFS2QeG54M4 .ant-checkbox-inner {
  height: 1.25rem;
  width: 1.25rem;
}

.jU03AO2UpGtEwslo7HKW {
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 700;
}

/* .pledgeListInnerTitle {
  @apply text-2xl lg:text-base font-bold lg:font-semibold;
} */
.XnwrhVOUJ1QMKMIewpjk {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 0.5rem;
}
.oeRVk4RWXlY8PUyx8F6d {
  margin-top: 0.5rem;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  text-align: center;
  font-family: Noto Sans;
  font-size: 1.875rem;
  line-height: 2.25rem;
  --tw-text-opacity: 1;
  color: rgb(3 120 209 / var(--tw-text-opacity, 1));
}
@media (min-width: 1024px) {

  .oeRVk4RWXlY8PUyx8F6d {
    padding-top: 1.25rem;
    font-size: 13px;
  }
}
.W0hf9l4O13obinrHOHyx {
  margin-top: 0.5rem;
  text-align: center;
  font-size: 28px;
  font-weight: 400;
}
@media (min-width: 1024px) {

  .W0hf9l4O13obinrHOHyx {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.pkfKznQwCDJMdnjlgvJs {
  display: flex;
  justify-content: center;
  font-family: Noto Sans;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 500;
}
@media (min-width: 1024px) {

  .pkfKznQwCDJMdnjlgvJs {
    justify-content: flex-start;
    font-size: 24px;
  }
}

.xLnc9vhB63JjQ5coAUOi {
  margin-bottom: 1.25rem;
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 1.25rem;
}

.XDo7GRBi3D4oFD7HcDRq {
  grid-template-columns: repeat(1, minmax(0, 1fr));
  align-items: flex-end;
}

@media (min-width: 768px) {

  .XDo7GRBi3D4oFD7HcDRq {
    grid-template-columns: 2fr 1fr;
  }
}

.Zd9R5ZqyHpfbyH4yYo8w {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.Zsj3mOLXBIAJ8IUAZrPn {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100%;
}

.B9t6iuOrEcXo9ygCmWw7 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.icC2yTy6I0BQJ_izV1ag {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/PledgeConsentApproval/PledgeConsentApproval.module.css"],"names":[],"mappings":"AACE;EAAA,aAAsD;EAAtD,kBAAsD;EAAtD,mBAAsD;EAAtD,uBAAsD;EACtD;;;;;AADsD;;AAStD;EAAA,WAC8C;EAD9C,kBAC8C;EAD9C,oBAC8C;EAD9C,qBAC8C;EAD9C,iBAC8C;EAD9C,oBAC8C;EAD9C,+EAC8C;EAD9C,mGAC8C;EAD9C;AAC8C;;AAD9C;;EAAA;IAAA;EAC8C;AAAA;;AAD9C;;EAAA;IAAA;EAC8C;AAAA;;AAD9C;;EAAA;IAAA;EAC8C;AAAA;;AAFhD;EAGE;;;;GAIC;AACH;;AAGE;EAAA,WAA2F;EAA3F,kBAA2F;EAA3F,oBAA2F;EAA3F,qBAA2F;EAA3F,mBAA2F;EAA3F,sBAA2F;EAA3F,+EAA2F;EAA3F,mGAA2F;EAA3F;AAA2F;;AAA3F;;EAAA;IAAA;EAA2F;AAAA;;AAA3F;;EAAA;IAAA;EAA2F;AAAA;;AAA3F;;EAAA;IAAA,UAA2F;IAA3F,mBAA2F;IAA3F;EAA2F;AAAA;;AAD7F;EAEE;;;;GAIC;AACH;AAEE;EAAA,eAA4B;EAA5B;AAA4B;AAA5B;;EAAA;IAAA,eAA4B;IAA5B;EAA4B;AAAA;;AAI5B;EAAA;AAAqB;;AAIrB;EAAA,mBAAkE;EAAlE,kBAAkE;EAAlE,sBAAkE;EAAlE,eAAkE;EAAlE;AAAkE;;AAAlE;;EAAA;IAAA,kBAAkE;IAAlE;EAAkE;AAAA;AAGlE;EAAA,mBAAkH;EAAlH,mBAAkH;EAAlH,kBAAkH;EAAlH,sBAAkH;EAAlH,eAAkH;EAAlH;AAAkH;AAAlH;;EAAA;IAAA,eAAkH;IAAlH,eAAkH;IAAlH;EAAkH;AAAA;AAGlH;EAAA,kBAAkE;EAAlE,mBAAkE;EAAlE,kBAAkE;EAAlE,eAAkE;EAAlE;AAAkE;AAAlE;;EAAA;IAAA,eAAkE;IAAlE;EAAkE;AAAA;AAGlE;EAAA,mBAAqC;EAArC,aAAqC;EAArC,uBAAqC;EAArC;AAAqC;AAGrC;EAAA,aAA2J;EAA3J,WAA2J;EAA3J,kBAA2J;EAA3J,iBAA2J;EAA3J,mBAA2J;EAA3J,sBAA2J;EAA3J,4DAA2J;EAA3J,kBAA2J;EAA3J,4DAA2J;EAA3J,kBAA2J;EAA3J,mBAA2J;EAA3J,oBAA2J;EAA3J;AAA2J;AAA3J;;EAAA;IAAA,YAA2J;IAA3J,WAA2J;IAA3J,eAA2J;IAA3J;EAA2J;AAAA;AAD7J;EAEE,aAAa;AACf;;AAGE;EAAA,kBAAgE;EAAhE,mBAAgE;EAAhE,kBAAgE;EAAhE,eAAgE;EAAhE;AAAgE;;AAAhE;;EAAA;IAAA,mBAAgE;IAAhE;EAAgE;AAAA;;AAIhE;EAAA,mBAA+B;EAA/B,aAA+B;EAA/B;AAA+B;;AAI/B;EAAA,YAAyC;EAAzC;AAAyC;;AAAzC;;EAAA;IAAA,YAAyC;IAAzC;EAAyC;AAAA;;AAIzC;EAAA,YAA4F;EAA5F,YAA4F;EAA5F,6BAA4F;EAA5F,qEAA4F;EAA5F,sBAA4F;EAA5F,eAA4F;EAA5F,oBAA4F;EAA5F;AAA4F;;AAA5F;EAAA,+BAA4F;EAA5F;AAA4F;;AAG9F;;GAEG;AAED;EAAA,iBACkC;EADlC,uBACkC;EADlC,sBACkC;EADlC,kBACkC;EADlC,0DACkC;EADlC,kBACkC;EADlC,mBACkC;EADlC,mBACkC;EADlC,sBACkC;EADlC,eACkC;EADlC,mBACkC;EADlC,gBACkC;EADlC,oBACkC;EADlC;AACkC;;AAIlC;EAAA,6BAAiC;EAAjC,qEAAiC;EAAjC,+BAAiC;EAAjC;AAAiC;;AAGnC;EACE,4CAA4C;EAC5C,aAAqD;EAArD,sBAAqD;EAArD,uBAAqD;EAArD,YAAqD;AACvD;;AADE;;EAAA;IAAA;EAAqD;AAAA;;AAGvD;EACE,0FAA0F;EAC1F,WAAyE;EAAzE,eAAyE;EAAzE,yBAAyE;KAAzE,sBAAyE;UAAzE,iBAAyE;EAAzE,qBAAyE;EAAzE,kBAAyE;EAAzE,4DAAyE;EAAzE,gBAAyE;AAC3E;;AADE;;EAAA;IAAA;EAAyE;AAAA;;AAIzE;EAAA,aAA2B;EAA3B;AAA2B;;AAI3B;EAAA;AAAW;;AAIX;EAAA,aAA0B;EAA1B,sBAA0B;EAA1B;AAA0B;;AAI1B;EAAA,eAA2C;EAA3C;AAA2C;;AAA3C;;EAAA;IAAA,mBAA2C;IAA3C;EAA2C;AAAA;;AAI3C;EAAA,eAAyC;EAAzC;AAAyC;;AAAzC;;EAAA;IAAA,kBAAyC;IAAzC;EAAyC;AAAA;;AAIzC;EAAA,mBAAqI;EAArI,aAAqI;EAArI,eAAqI;EAArI,mBAAqI;EAArI,uBAAqI;EAArI,YAAqI;EAArI,kBAAqI;EAArI,sBAAqI;EAArI,mBAAqI;EAArI,oBAAqI;EAArI,oBAAqI;EAArI;AAAqI;;AAArI;;EAAA;IAAA,oBAAqI;IAArI;EAAqI;AAAA;;AAGvI;;;;;;;;;;;;;;;GAeG;;AAGD;EAAA,YAAiG;EAAjG,WAAiG;EAAjG,kBAAiG;EAAjG,0DAAiG;EAAjG,oBAAiG;EAAjG,qBAAiG;EAAjG,eAAiG;EAAjG,mBAAiG;EAAjG,gBAAiG;EAAjG,oBAAiG;EAAjG;AAAiG;;AAAjG;;EAAA;IAAA,YAAiG;IAAjG,uBAAiG;IAAjG;EAAiG;AAAA;;AAIjG;EAAA,6BAAiC;EAAjC,qEAAiC;EAAjC,+BAAiC;EAAjC;AAAiC;;AAIjC;EAAA,YAAiG;EAAjG,WAAiG;EAAjG,kBAAiG;EAAjG,0DAAiG;EAAjG,oBAAiG;EAAjG,qBAAiG;EAAjG,eAAiG;EAAjG,mBAAiG;EAAjG,gBAAiG;EAAjG,oBAAiG;EAAjG;AAAiG;;AAAjG;;EAAA;IAAA,YAAiG;IAAjG,uBAAiG;IAAjG;EAAiG;AAAA;;AAIjG;EAAA,6BAAiC;EAAjC,qEAAiC;EAAjC,+BAAiC;EAAjC;AAAiC;;AAIjC;EAAA,YACqD;EADrD,WACqD;EADrD,6BACqD;EADrD,qEACqD;EADrD,oBACqD;EADrD,qBACqD;EADrD,eACqD;EADrD,mBACqD;EADrD,gBACqD;EADrD,oBACqD;EADrD;AACqD;;AADrD;EAAA,+BACqD;EADrD;AACqD;;AADrD;;EAAA;IAAA,YACqD;IADrD,uBACqD;IADrD;EACqD;AAAA;;AAIrD;EAAA;AAA4B;;AAA5B;;EAAA;IAAA;EAA4B;AAAA;AAG5B;EAAA,kBAA6B;EAA7B;AAA6B;AAA7B;;EAAA;IAAA,kBAA6B;IAA7B;EAA6B;AAAA;AAA7B;;EAAA;IAAA,mBAA6B;IAA7B;EAA6B;AAAA;AAG7B;EAAA,aAAyF;EAAzF,gBAAyF;EAAzF,WAAyF;EAAzF,sBAAyF;EAAzF,mBAAyF;EAAzF,oBAAyF;EAAzF;AAAyF;AAAzF;;EAAA;IAAA,mBAAyF;IAAzF;EAAyF;AAAA;AAE3F;;GAEG;AAED;EAAA,mBAAkG;EAAlG,sBAAkG;EAAlG,aAAkG;EAAlG,WAAkG;EAAlG,sBAAkG;EAAlG,mBAAkG;EAAlG;AAAkG;AAAlG;;EAAA;IAAA,UAAkG;IAAlG,mBAAkG;IAAlG,yBAAkG;IAAlG;EAAkG;AAAA;AAGlG;EAAA,mBAAyB;EAAzB;AAAyB;AAAzB;;EAAA;IAAA;EAAyB;AAAA;AAE3B;;GAEG;AAED;EAAA,aAAyE;EAAzE,sBAAyE;EAAzE;AAAyE;AAAzE;;EAAA;IAAA,mBAAyE;IAAzE,mBAAyE;IAAzE;EAAyE;AAAA;;AAIzE;EAAA,aAAwC;EAAxC,eAAwC;EAAxC,mBAAwC;EAAxC;AAAwC;;AAIxC;EAAA,eAA4B;EAA5B,mBAA4B;EAA5B;AAA4B;;AAI5B;EAAA,eAAc;EAAd;AAAc;;AAId;EAAA,mBAAwB;EAAxB,oBAAwB;EAAxB;AAAwB;;AAG1B;;GAEG;AAED;EAAA,aAAiC;EAAjC,WAAiC;EAAjC,sBAAiC;EAAjC;AAAiC;AAGjC;EAAA,kBAAqI;EAArI,aAAqI;EAArI,eAAqI;EAArI,mBAAqI;EAArI,uBAAqI;EAArI,YAAqI;EAArI,kBAAqI;EAArI,sBAAqI;EAArI,mBAAqI;EAArI,oBAAqI;EAArI,oBAAqI;EAArI;AAAqI;AAArI;;EAAA;IAAA,oBAAqI;IAArI;EAAqI;AAAA;AAGrI;EAAA,kBAA4D;EAA5D,kBAA4D;EAA5D,eAA4D;EAA5D;AAA4D;AAA5D;;EAAA;IAAA,eAA4D;IAA5D;EAA4D;AAAA;AAG5D;EAAA,aAA2F;EAA3F,uBAA2F;EAA3F,sBAA2F;EAA3F,eAA2F;EAA3F,mBAA2F;EAA3F;AAA2F;AAA3F;;EAAA;IAAA,2BAA2F;IAA3F;EAA2F;AAAA;;AAI3F;EAAA,sBAAkC;EAAlC,aAAkC;EAAlC,gDAAkC;EAAlC;AAAkC;;AAIlC;EAAA,gDAAmD;EAAnD;AAAmD;;AAAnD;;EAAA;IAAA;EAAmD;AAAA;;AAInD;EAAA;AAAkB;;AAGpB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb","sourcesContent":[".gradientBg {\n  @apply flex items-center justify-center min-h-[100dvh];\n  background: linear-gradient(\n    116.81deg,\n    rgba(3, 120, 209, 0.25) -7.65%,\n    rgba(255, 255, 255, 0.25) 71.29%\n  );\n}\n\n.formContainerInitial {\n  @apply rounded-[5px] shadow-lg px-6 pt-8 pb-16 \n         w-full sm:w-[95%] md:w-[85%] lg:w-[60%];\n  background: linear-gradient(\n    287deg,\n    rgba(3, 120, 209, 0.08) -7.65%,\n    rgba(255, 255, 255, 0.08) 71.29%\n  );\n}\n\n.formContainer {\n  @apply rounded-[5px] shadow-lg px-6 py-14 lg:py-10  w-full sm:w-[95%] md:w-[90%] lg:w-[40%];\n  background: linear-gradient(\n    116.81deg,\n    rgba(3, 120, 209, 0.08) -7.65%,\n    rgba(255, 255, 255, 0.08) 71.29%\n  );\n}\n.backArrowLogo {\n  @apply w-5 h-5 lg:w-3 lg:h-3;\n}\n\n.formContainer :global(.ant-input-outlined) {\n  @apply !rounded-[5px];\n}\n\n.loginHeading {\n  @apply text-[34px] lg:text-xl font-bold font-noto text-center mb-4;\n}\n.concentPageHeading {\n  @apply text-[48px] lg:text-[48px] font-extrabold lg:font-bold font-noto text-center mt-5 lg:mt-0 whitespace-nowrap;\n}\n.subtitleForLoginHeading {\n  @apply font-normal text-[28px] lg:text-base text-center mt-2 mb-12;\n}\n.otpWrapper {\n  @apply flex justify-center gap-4 mt-5;\n}\n.otpInput {\n  @apply w-full lg:w-[60px] h-[110px] lg:h-[60px] text-center text-3xl lg:text-base font-medium rounded-[5px] bg-otpInput border border-solid border-gray-200;\n  outline: none;\n}\n\n.subtitle {\n  @apply font-normal text-[28px] lg:text-lg text-center mt-2 mb-12;\n}\n\n.logo {\n  @apply flex justify-center mb-4;\n}\n\n.logoImage {\n  @apply w-[330px] lg:w-[200px] h-12 lg:h-8;\n}\n\n.mykadBtn {\n  @apply !bg-[#2E3192] w-[220px] h-[44px] text-[14px] font-inter text-white  hover:!text-white;\n}\n\n/* .cancelBtn {\n  @apply bg-danger-800 text-white text-2xl lg:text-base font-semibold lg:font-normal px-6 py-2 !w-52 lg:!w-[130px] !h-[60px] lg:!h-[38px] mr-2;\n} */\n.cancelBtn {\n  @apply bg-danger-800 text-white text-base font-semibold\n    px-4 py-2 !w-auto !h-[42px] mr-0;\n}\n\n.cancelBtn:hover {\n  @apply !bg-danger-800 !text-white;\n}\n\n.wrapper {\n  /* @apply flex gap-5 flex-col md:flex-row; */\n  @apply flex flex-col lg:flex-row justify-center gap-5;\n}\n\n.card {\n  /* @apply flex flex-col flex-1 p-5 gap-5 bg-white rounded-lg cursor-pointer select-none; */\n  @apply bg-white rounded-lg cursor-pointer select-none p-5 w-full lg:w-1/2;\n}\n\n.cardHeader {\n  @apply flex justify-between;\n}\n\n.icon {\n  @apply w-10;\n}\n\n.content {\n  @apply flex flex-col gap-2;\n}\n\n.title {\n  @apply font-semibold text-[28px] lg:text-lg;\n}\n\n.subtitleCard {\n  @apply font-normal text-[23px] lg:text-xs;\n}\n\n.footerBack {\n  @apply text-3xl lg:text-[13px] text-primary mt-7 lg:pt-5 font-inter flex items-center justify-center text-center gap-1 cursor-pointer;\n}\n\n/* .signpassButton {\n  @apply bg-danger-600 text-white w-full font-bold lg:font-semibold lg:w-fit h-[85px] lg:h-[40px] text-3xl lg:text-base;\n}\n.signpassButton:hover {\n  @apply !bg-danger-600 !text-white;\n}\n\n.mykadButton {\n  @apply bg-mykadColor text-white font-bold lg:font-semibold w-full lg:w-fit h-[85px] lg:h-[40px] text-3xl lg:text-base;\n}\n.mykadButton:hover {\n  @apply !bg-mykadColor !text-white;\n}\n.primaryBtn {\n  @apply !bg-primary font-bold lg:font-semibold text-white  hover:!text-white w-full lg:w-fit h-[85px] lg:h-[40px] text-3xl lg:text-base px-3;\n} */\n\n.signpassButton {\n  @apply bg-danger-600 text-white w-full lg:w-fit font-semibold h-[56px] lg:h-[52px] text-base px-6;\n}\n\n.signpassButton:hover {\n  @apply !bg-danger-600 !text-white;\n}\n\n.mykadButton {\n  @apply bg-mykadColor text-white font-semibold w-full lg:w-fit h-[56px] lg:h-[52px] text-base px-6;\n}\n\n.mykadButton:hover {\n  @apply !bg-mykadColor !text-white;\n}\n\n.primaryBtn {\n  @apply !bg-primary font-semibold text-white hover:!text-white\n    w-full lg:w-fit h-[56px] lg:h-[52px] text-base px-6;\n}\n\n.signpassIcon {\n  @apply w-[100px] lg:w-[70px];\n}\n.pledgeListWrapper {\n  @apply px-4 lg:px-20 xl:px-40;\n}\n.pledgeListHeaderWrapper {\n  @apply flex flex-col py-5 lg:flex-row lg:justify-between items-center w-full min-h-[80px];\n}\n/* .pledgeListButtonWrapper {\n  @apply flex flex-col lg:flex-row lg:justify-end gap-9 lg:gap-2 items-center my-5 w-full lg:w-[70%];\n} */\n.pledgeListButtonWrapper {\n  @apply flex flex-col lg:flex-row lg:justify-end gap-4 lg:gap-3 items-center my-5 w-full lg:w-[70%];\n}\n.pledgeListInnerWrapper {\n  @apply mb-4 mt-14 lg:mt-2;\n}\n/* .pledgeListInnerWrapperHeader {\n  @apply flex justify-between items-center;\n} */\n.pledgeListInnerWrapperHeader {\n  @apply flex flex-col gap-3 lg:flex-row lg:justify-between lg:items-center;\n}\n\n.pledgeListInnerWrapperHeader > div {\n  @apply flex flex-wrap items-center gap-3;\n}\n\n.pledgeListInnerWrapperHeader :global(.ant-checkbox-wrapper) {\n  @apply text-base font-medium;\n}\n\n.pledgeListInnerWrapperHeader :global(.ant-checkbox-inner) {\n  @apply w-5 h-5;\n}\n\n.pledgeListInnerTitle {\n  @apply text-lg font-bold;\n}\n\n/* .pledgeListInnerTitle {\n  @apply text-2xl lg:text-base font-bold lg:font-semibold;\n} */\n.pledgePDFPreview {\n  @apply flex flex-col gap-2 w-full;\n}\n.footerBackSuccess {\n  @apply text-3xl lg:text-[13px] text-primary mt-2 lg:pt-5 font-inter flex items-center justify-center text-center gap-1 cursor-pointer;\n}\n.subtitleForSuccessHeading {\n  @apply font-normal text-[28px] lg:text-base text-center mt-2;\n}\n.noPledgesTitle {\n  @apply text-base lg:text-[24px] font-inter font-medium flex justify-center lg:justify-start;\n}\n\n.customerGrid {\n  @apply grid grid-cols-1 gap-5 mb-5;\n}\n\n.customerGridWithOwner {\n  @apply grid-cols-1 md:grid-cols-[2fr_1fr] items-end;\n}\n\n.customerGridWithoutOwner {\n  @apply grid-cols-1;\n}\n\n.invalidDivWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  width: 100%;\n}\n\n.invalidDivInnerWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.invalidDivContentWrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gradientBg": `uLJTyxCFZTI16HbtzA3w`,
	"formContainerInitial": `AOd0HsBLI5S4JY5rOqp5`,
	"formContainer": `mrBrMTwf0eiQAR3ykeNs`,
	"backArrowLogo": `pRqQf9LVFmb3LuQLK1rC`,
	"loginHeading": `Qt9H8mMtyKiYtDJSs_aK`,
	"concentPageHeading": `axXbqR0fo7PtPQdqXJ4f`,
	"subtitleForLoginHeading": `FtvJ8h8jI0UejcfzyRim`,
	"otpWrapper": `K342D5ZpqRD2D2RgaHqQ`,
	"otpInput": `TfAbDrjgSN0wI8UpfNMg`,
	"subtitle": `x7i4UGtc2w2XB44OI2wj`,
	"logo": `J9JydlldFNnMk0_p5pBD`,
	"logoImage": `rky8XFw8bdVaUG6yGu7s`,
	"mykadBtn": `SlZj8TwiOCtKZsqIbyD_`,
	"cancelBtn": `UJ39q2ypqv9eDgaR0uFj`,
	"wrapper": `nEBmZhLgw7m6cA9VQUH7`,
	"card": `YgPj0EI3rUd7lGXB95f7`,
	"cardHeader": `EMU1fk3VRPMuOzc7nWE3`,
	"icon": `raWqWYWcpKbw_PwAfVv5`,
	"content": `Hn5vejhSU6cpb8_lfRjv`,
	"title": `gzEUwuHQPRJI4XRVCDwQ`,
	"subtitleCard": `n3LfLfdgzlh49W9PDwuA`,
	"footerBack": `rGFrRhxZYBN_RrEpgUQn`,
	"signpassButton": `ZZmH6LLjddJZQ49D6XGX`,
	"mykadButton": `vj2NL9QHGFCj5NDShvac`,
	"primaryBtn": `UXRryY5q1IqERHZaYJQa`,
	"signpassIcon": `HGbkvu4_bl6OFoZEndgz`,
	"pledgeListWrapper": `YCFdm0CoUtqJmEiy8FVg`,
	"pledgeListHeaderWrapper": `LxcUsCy4r8LcpQ47HoJr`,
	"pledgeListButtonWrapper": `gv6XIKf7c7RWyIp3sBGF`,
	"pledgeListInnerWrapper": `ydCuPGNWxOGPDFEX8hCo`,
	"pledgeListInnerWrapperHeader": `uMNcmnGq3NFS2QeG54M4`,
	"pledgeListInnerTitle": `jU03AO2UpGtEwslo7HKW`,
	"pledgePDFPreview": `XnwrhVOUJ1QMKMIewpjk`,
	"footerBackSuccess": `oeRVk4RWXlY8PUyx8F6d`,
	"subtitleForSuccessHeading": `W0hf9l4O13obinrHOHyx`,
	"noPledgesTitle": `pkfKznQwCDJMdnjlgvJs`,
	"customerGrid": `xLnc9vhB63JjQ5coAUOi`,
	"customerGridWithOwner": `XDo7GRBi3D4oFD7HcDRq`,
	"customerGridWithoutOwner": `Zd9R5ZqyHpfbyH4yYo8w`,
	"invalidDivWrapper": `Zsj3mOLXBIAJ8IUAZrPn`,
	"invalidDivInnerWrapper": `B9t6iuOrEcXo9ygCmWw7`,
	"invalidDivContentWrapper": `icC2yTy6I0BQJ_izV1ag`
};
export default ___CSS_LOADER_EXPORT___;
